import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { initTrafficSource } from "./utils/trafficSource";
import "./assets/sass/reset.scss";
import "./assets/sass/global.scss";
import "./assets/sass/fonts.scss";
import { createI18n } from "vue-i18n";
import { vMaska } from "maska";
import VueCarousel from "vue-carousel";
import dataFetching from "./axios/instance";
import Pusher from "pusher-js";

import { languages } from "./locales/settings.js";
import { defaultLocale } from "./locales/settings.js";
const messages = Object.assign(languages);

const i18n = createI18n({
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  locale: defaultLocale,
  fallbackLocale: "kz",
  warnHtmlInMessage: "off",
  messages,
});

const app = createApp(App);

app.config.globalProperties.$pusher = new Pusher("9eed0f9c76dc0800dc4d", {
  cluster: "ap1",
});
app.use(router).use(VueCarousel).use(i18n);
app.directive("maska", vMaska);
app.config.globalProperties.$dataFetching = dataFetching;
initTrafficSource();
app.mount("#app");
